import React, {useEffect} from 'react';
import {BrowserRouter,Routes,Route} from "react-router-dom";
import Home from "./pages/Home";
import History from "./pages/History";
import SipNumber from "./pages/SipNumber";
import Included from "./pages/Included";
import ShortNumber from "./pages/ShortNumber";
import Ivr from "./pages/Ivr";
import DidNumbers from "./pages/DidNumbers";
import SipProvider from "./pages/SipProvider";
import Forward from "./pages/Forward";
import CallRout from "./pages/CallRout";
import AutoCall from "./pages/AutoCall";
import Files from "./pages/Files";
import Blocked from "./pages/Blocked";
import Ip from "./pages/Ip";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import AutoCallEdit from "./pages/AutoCallEdit";
import Profile from "./pages/Profile";
import UrsLogin from "./pages/UrsLogin";
import Urs from "./pages/Urs";
import Confirm from "./pages/Confirm";
import ShortFunction from "./pages/ShortFunction";
import ClGroup from "./pages/ClGroup";
import Register from "./pages/Register";
import BlockedIp from "./pages/BlockedIp";
import Online from "./pages/Online";
import CrmIntegration from "./pages/CrmIntegration";
import Bitrix24 from "./pages/Bitrix24";
import UrsOnline from "./pages/UrsOnline";
import UrsUsed from "./pages/UrsUsed";
import UrsReports from "./pages/UrsReports";
import Logs from "./pages/Logs";
import Zoho from "./pages/Zoho";
import Amo from "./pages/Amo";
import YourCrm from "./components/YourCrm";
import TelegramPage from "./pages/TelegramPage";
import Pipedrive from "./pages/Pipedrive";
import Monday from "./pages/Monday";
import DragConnect from "./pages/DragConnect";
import Altegio from "./pages/Altegio";
import Retail from "./pages/Retail";
import Uon from "./pages/Uon";
import Statistic from "./pages/Statistic";
import CallCenter from "./pages/CallCenter";
import SpyServer from "./pages/SpyServer";
import AutoCallUpload from "./pages/AutoCallUpload";
import Drop from "./pages/Drop";
import UrsNews from "./pages/UrsNews";
import QrLogin from "./pages/QrLogin";
import UrsInBlock from "./pages/UrsInBlock";
import UrsBlocked from './pages/UrsBlocked';
import Rezx from './pages/Rezx';
import CrmsAm from './pages/CrmsAm';
import Hubspot from "./pages/Hubspot";
import Lua from "./pages/Lua";
import Rate from "./pages/new_operator/Rate";
import OpenAI from "./pages/new_operator/OpenAI";
import AiAnalytics from "./pages/new_operator/AiAnalytics";
import AiAnalyticsList from "./pages/new_operator/AiAnalyticsList";
import Widget from "./pages/new_operator/Widget";
import Chats from "./pages/new_operator/Chats";
import Connects from "./pages/new_operator/Connects";
import TelegramInteg from "./pages/new_operator/TelegramInteg";
import SipSingle from "./pages/new_operator/SipSingle";
import Groups from "./pages/new_operator/Groups";
import Group from "./pages/new_operator/Group";
import Employees from "./pages/new_operator/Employees";
import EmployeeUpload from "./pages/new_operator/EmployeeUpload";
import EmployeePermissions from "./pages/new_operator/EmployeePermissions";
import RoleViewPage from "./pages/new_operator/RoleViewPage";
import IvrSingle from "./pages/new_operator/IvrSingle";
import Ivrs from "./pages/new_operator/Ivrs";
import MainNumber from "./pages/new_operator/MainNumber";
import DidSingle from "./pages/new_operator/DidSingle";
import AutoCallList from "./pages/new_operator/AutoCallList";
import GroupCallList from "./pages/new_operator/GroupCallList";
import ConferenceCallList from "./pages/new_operator/ConferenceCallList";
import AutoCallSingle from "./pages/new_operator/AutoCallSingle";
import ConferenceCallSingle from "./pages/new_operator/ConferenceCallSingle";
import AutoCallExcelUpload from "./pages/new_operator/AutoCallExcelUpload";
import SipProvidersSingle from "./pages/new_operator/SipProvidersSingle";
import SipProviders from "./pages/new_operator/SIpProviders";
import BlockedNumbers from "./pages/new_operator/BlockedNumbers";
import Activities from "./pages/new_operator/Activities";
import MusicHold from "./pages/new_operator/MusicHold";
import NewVisual from "./pages/new_operator/NewVisual";
import HistoryChats from "./components/new_component/HistoryChats";
import TelegramConnectChats from "./pages/new_operator/TelegramConnectChats";
import WhatsAppConnectNumbers from "./pages/new_operator/WhatsAppConnectNumbers";
import WhatsAppOAuthCallback from "./pages/new_operator/WhatsAppOAuthCallback";
import OperatorReport from "./pages/new_operator/OperatorReport";
import NewOnline from "./pages/new_operator/Online";
import CallCenterSettings from "./pages/new_operator/CallCenterSettings";
import SendMailEmployee from "./pages/new_operator/SendMailEmployee";
import SmsProvidingMain from "./pages/new_operator/SmsProvidingMain";
import SmsProvidingCreate from "./pages/new_operator/SmsProvidingCreate";
import SipSpeech from "./pages/new_operator/SipSpeech";
import VoiceMailFamiliar from "./pages/new_operator/VoiceMailFamiliar";
import ShortFunctionSpy from "./pages/new_operator/ShortFunctionSpy";
import OperatorHistory from "./pages/new_operator/OperatorHistory";
import WhatsappHistory from "./pages/new_operator/WhatsappHistory";
import { useSelector } from "react-redux";
import Cookies from 'js-cookie';
import DockLauncher from './components/DockLauncher';
import RequirePermission from './components/RequirePermission';
import RequireHistoryView from './components/RequireHistoryView';
import RequireReportView from './components/RequireReportView';
import BitrixHandler from './pages/new_operator/BitrixHandler';
import HelpDesk from './pages/new_operator/HelpDesk';
import Agreement from './pages/Agreement';
import PrivacyPolicy from './pages/PrivacyPolicy';
import UrsPromocodes from './pages/UrsPromocodes';
import UrsAdmGroup from './pages/UrsAdmGroup';
import PromocodeModal from './components/new_component/PromocodeModal';
const {REACT_APP_SERVER} = process.env;
let background = REACT_APP_SERVER === 'ATS'?'#0973b9':'#7ebc0a'
let color = REACT_APP_SERVER === 'ATS'?'#162585':'#5e8516'

function App(props) {
    useEffect(() => {
        document.documentElement.style.setProperty('--background', background);
        document.documentElement.style.setProperty('--color', color);

    }, [color,background,REACT_APP_SERVER])
    const employeeData = useSelector(state => state.users.employeeData)
    const userData = useSelector(state => state.users.userData)
    const profile = useSelector(state => state.users.ursData)
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home/>} />
                <Route path="/qr_login" element={<QrLogin/>} />
                <Route path="/sip_number" element={<SipNumber/>} />
                <Route path="/employees" element={<RequirePermission permission="employees_read"><Employees/></RequirePermission>} />
                <Route path="/employees/upload" element={<RequirePermission permission="employees_read"><EmployeeUpload/></RequirePermission>} />
                <Route path="/short_function/employees/permissions" element={<RequirePermission permission="employees_read"><EmployeePermissions/></RequirePermission>} />
                <Route path="/short_function/employees/permissions/role/:roleId" element={<RequirePermission permission="employees_read"><RoleViewPage/></RequirePermission>} />
                <Route path="/employees/:id" element={<RequirePermission permission="employees_read"><SipSingle/></RequirePermission>} />
                <Route path="/main_number" element={<RequirePermission permission="did_read"><MainNumber/></RequirePermission>} />
                <Route path="/auto_call_list" element={<RequirePermission permission="crm_integrations_manage"><AutoCallList listType="autocall"/></RequirePermission>} />
                <Route path="/group_call_list" element={<RequirePermission permission="crm_integrations_manage"><GroupCallList/></RequirePermission>} />
                <Route path="/auto_call_single/upload/:id" element={<RequirePermission permission="crm_integrations_manage"><AutoCallExcelUpload/></RequirePermission>} />
                <Route path="/auto_call_single/:id" element={<RequirePermission permission="crm_integrations_manage"><AutoCallSingle/></RequirePermission>} />
                <Route path="/conference_call_list" element={<RequirePermission permission="crm_integrations_manage"><ConferenceCallList/></RequirePermission>} />
                <Route path="/conference_call_single/:id" element={<RequirePermission permission="crm_integrations_manage"><ConferenceCallSingle/></RequirePermission>} />
                <Route path="/main_number/:id" element={<RequirePermission permission="did_read"><DidSingle/></RequirePermission>} />
                <Route path="/groups" element={<RequirePermission permission="groups_read"><Groups/></RequirePermission>} />
                <Route path="/groups/:id" element={<RequirePermission permission="groups_read"><Group/></RequirePermission>} />
                <Route path="/sip_providers/:id" element={<RequirePermission permission="crm_integrations_manage"><SipProvidersSingle/></RequirePermission>} />
                <Route path="/sip_providers" element={<RequirePermission permission="crm_integrations_manage"><SipProviders/></RequirePermission>} />
                <Route path="/ivrs" element={<RequirePermission permission="ivr_read"><Ivrs/></RequirePermission>} />
                <Route path="/ivr_single/:id" element={<RequirePermission permission="ivr_read"><IvrSingle/></RequirePermission>} />
                <Route path="/urs_news" element={<HelpDesk/>} />
                <Route path="/statistic" element={<Statistic/>} />
                <Route path="/help_desk" element={<HelpDesk/>} />
                <Route path="/spy_server" element={<SpyServer/>} />
                <Route path="/to_block" element={<UrsInBlock/>} />
                <Route path="/crm_integration" element={<RequirePermission permission="crm_integrations_manage"><CrmIntegration/></RequirePermission>} />
                <Route path="/crm_integration/bitrix" element={<RequirePermission permission="crm_integrations_manage"><Bitrix24/></RequirePermission>} />
                <Route path="/crm_integration/amo" element={<RequirePermission permission="crm_integrations_manage"><Amo/></RequirePermission>} />
                <Route path="/crm_integration/custom" element={<RequirePermission permission="crm_integrations_manage"><YourCrm/></RequirePermission>} />
                <Route path="/crm_integration/zoho" element={<RequirePermission permission="crm_integrations_manage"><Zoho/></RequirePermission>} />
                <Route path="/crm_integration/altegio" element={<RequirePermission permission="crm_integrations_manage"><Altegio/></RequirePermission>} />
                <Route path="/crm_integration/pipedrive" element={<RequirePermission permission="crm_integrations_manage"><Pipedrive/></RequirePermission>} />
                <Route path="/crm_integration/monday" element={<RequirePermission permission="crm_integrations_manage"><Monday/></RequirePermission>} />
                <Route path="/crm_integration/retail" element={<RequirePermission permission="crm_integrations_manage"><Retail/></RequirePermission>} />
                <Route path="/crm_integration/uon" element={<RequirePermission permission="crm_integrations_manage"><Uon/></RequirePermission>} />
                <Route path="/crm_integration/callcenter" element={<RequirePermission permission="crm_integrations_manage"><CallCenter/></RequirePermission>} />
                <Route path="/short_function/call_center" element={<RequirePermission permission="crm_integrations_manage"><CallCenterSettings/></RequirePermission>} />
                <Route path="/crm_integration/rezx" element={<RequirePermission permission="crm_integrations_manage"><Rezx/></RequirePermission>} />
                <Route path="/crm_integration/crmsam" element={<RequirePermission permission="crm_integrations_manage"><CrmsAm/></RequirePermission>} />
                <Route path="/crm_integration/hubspot" element={<RequirePermission permission="crm_integrations_manage"><Hubspot/></RequirePermission>} />
                <Route path="/crm_integration/lua" element={<RequirePermission permission="crm_integrations_manage"><Lua/></RequirePermission>} />
                <Route path="/short_function/activities" element={<Activities/>} />
                <Route path="/short_function/rate" element={<Rate/>} />
                <Route path="/short_function/music_hold" element={<MusicHold/>} />
                <Route path="/short_function/pre_call_announcement" element={<MusicHold/>} />
                <Route path="/short_function/callback" element={<MusicHold/>} />
                <Route path="/short_function/send_mail_employee" element={<SendMailEmployee/>} />
                <Route path="/short_function/sms_providing" element={<RequirePermission permission="employees_read"><SmsProvidingMain/></RequirePermission>} />
                <Route path="/short_function/sms_providing/create" element={<RequirePermission permission="employees_read"><SmsProvidingCreate/></RequirePermission>} />
                <Route path="/short_function/speech" element={<SipSpeech/>} />
                <Route path="/short_function/spy" element={<ShortFunctionSpy/>} />
                <Route path="/short_function/config" element={<VoiceMailFamiliar/>} />
                <Route path="/short_function/openai" element={<OpenAI/>} />
                <Route path="/short_function/ai_analytics" element={<AiAnalyticsList/>} />
                <Route path="/short_function/ai_analytics/:analyticsId" element={<AiAnalytics/>} />
                <Route path="/connect/telegram-number" element={<TelegramConnectChats/>} />
                <Route path="/connect/whatsapp-number" element={<WhatsAppConnectNumbers/>} />
                <Route path="/connect/whatsapp-callback" element={<WhatsAppOAuthCallback/>} />
                <Route path="/short_function/connect/whatsapp-outh" element={<WhatsAppOAuthCallback/>} />
                <Route path="/short_function/widget" element={<Widget/>} />
                <Route path="/connect/:type" element={<Connects/>} />
                <Route path="/connect/:type/:accountId" element={<Chats/>} />
                <Route path="/connect/telegram/telegram_integr/:type" element={<TelegramInteg/>} />
                <Route path="/short_function/connect/:type" element={<Connects/>} />
                <Route path="/short_function/chats/:type/:accountId" element={<Chats/>} />
                <Route path="/short_function/telegram_integr/:type" element={<TelegramInteg/>} />
                <Route path="/history_telegram/:accountId" element={<HistoryChats/>} />
                <Route path="/history_telegram/" element={<HistoryChats/>} />
                <Route path="/history_whatsapp/:accountId" element={<WhatsappHistory/>} />
                <Route path="/history_whatsapp" element={<WhatsappHistory/>} />
                <Route path="/online" element={<Online/>} />
                <Route path="/urs_online" element={<UrsOnline/>} />
                <Route path="/urs_blocked" element={<UrsBlocked/>} />
                <Route path="/visualization" element={<NewVisual/>} />
                <Route path="/urs_used" element={<UrsUsed />} />
                <Route path="/telegram" element={<TelegramPage />} />
                <Route path="/registration" element={<Register/>} />
                <Route path="/drop_pass" element={<Drop/>} />
                <Route path="/clgroup" element={<ClGroup/>} />
                <Route path="/history" element={<RequireHistoryView><History/></RequireHistoryView>} />
                <Route path="/graphic" element={<RequireHistoryView><History/></RequireHistoryView>} />
                <Route path="/included" element={<Included/>} />
                <Route path="/short_numbers" element={<ShortNumber/>} />
                <Route path="/short_function" element={<ShortFunction/>} />
                <Route path="/ivr" element={<Ivr/>} />
                <Route path="/did_numbers" element={<DidNumbers/>} />
                <Route path="/sip_provider" element={<SipProvider/>} />
                <Route path="/forward" element={<Forward/>} />
                <Route path="/rout_phone_number" element={<CallRout/>} />
                <Route path="/auto_call" element={<AutoCall/>} />
                <Route path="/auto_call/:id" element={<AutoCallEdit/>} />
                <Route path="/auto_call/upload/:id" element={<AutoCallUpload/>} />
                <Route path="/files" element={<Files/>} />
                <Route path="/blocked" element={<Blocked/>} />
                <Route path="/blocked_numbers" element={<BlockedNumbers/>} />
                <Route path="/blocked_ip" element={<BlockedIp/>} />
                <Route path="/ip" element={<Ip/>} />
                <Route path="/login" element={<Login/>} />
                <Route path="/admin_login" element={<UrsLogin/>} />
                <Route path="/urs" element={<Urs/>} />
                <Route path="/confirm/:type/:phone" element={<Confirm/>} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/report" element={<UrsReports />} />
                <Route path="/logs" element={<Activities />} />
                <Route path="/new_visual" element={<NewVisual/>} />
                <Route path="/operator_report" element={<RequireReportView><OperatorReport/></RequireReportView>} />
                <Route path="/operator_report/:type" element={<RequireReportView><OperatorReport/></RequireReportView>} />
                <Route path="/not-found" element={<NotFound/>} />
                <Route path="/bitrix24/index" element={<BitrixHandler/>} />
                <Route path="/operator_history" element={<RequireHistoryView><OperatorHistory/></RequireHistoryView>} />
                <Route path="/agreement" element={<Agreement/>} />
                <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
                <Route path="/urs_promocodes" element={<UrsPromocodes/>} />
                <Route path="/urs_admgroup" element={<UrsAdmGroup/>} />

                <Route path="/*" element={<NotFound/>} />
            </Routes>
           {userData?.id && !profile?.id && REACT_APP_SERVER !== "ATS" ? <DockLauncher
                showPhone={!!employeeData && !!employeeData?.isweb}
                showChat={!Cookies.get('viewer') && REACT_APP_SERVER !== "Beeline"}
                sipProps={{
                    sip: {
                        wssServer: "wss://wusip.ats.am:8089/ws",
                        domain: "wusip.ats.am",
                        user: employeeData?.buddy,
                        password: employeeData?.sip?.secret,
                    },
                }}
            />:null}
            <PromocodeModal />

        </BrowserRouter>
    );
}

export default App;
